import React, {useEffect, useState} from "react";
import $ from 'jquery';
import {useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";
import {confirmAlert, errorAlert} from "../../Components/Alerts/BasicAlert";
import axios from "axios";
import "../../assets/css/pages/admins.css";
import swal from 'sweetalert';
import _ from "lodash";
import avatarBlank from "../../assets/media/svg/avatar-blank.svg";

export default function () {
  const navigate = useNavigate();
  const token = useSelector(state => state.token);
  const user = useSelector(state => state.user);
  const isSuperAdmin = user?.roles?.includes('Super Admin');
  const [bulkArray, setBulkArray] = useState([]);
  const buttonIsDisabled = !bulkArray.length;
  const filterInitialValues = {
    id: "",
    first_name: "",
    last_name: "",
    email: "",
    role: "",
    only_blocked: false,
  }

  const [filterParams, setFilterParams] = useState(filterInitialValues);
  const [onlyBlockedChecked, setOnlyBlockedChecked] = useState(false);

  useEffect(() => {
    if (onlyBlockedChecked == false) {
      delete filterParams.only_blocked;
    }
    triggerDatatable();
  }, []);

  const triggerFilter = (e) => {
    e.preventDefault();
    localStorage.removeItem("DataTables_admins_/admins");
    if (onlyBlockedChecked == false) {
      delete filterParams.only_blocked;
    }
    triggerDatatable();
  }

  const triggerDatatable = (resetFilter = false) => {
    const baseUrl = process.env.REACT_APP_API_URL;

    let table = $('#admins').DataTable({
      "ajax": {
        url: process.env.REACT_APP_API_URL + "admins/filter",
        method: 'POST',
        data: resetFilter ? {} : filterParams,
        beforeSend: function (request) {
          request.setRequestHeader("Authorization", 'Bearer ' + token);
        },
        error: function (xhr) {
          if (xhr?.status === 401) {
            axios.defaults.baseURL = process.env.REACT_APP_API_CLEAN_URL;
            axios.post('/logout')
              .then(
                localStorage.removeItem('persist:root'),
                navigate('/login')
              );
          }
        }
      },
      "destroy": true,
      "columns": [
        {
          data: 'checkbox',
          searchable: false,
          orderable: false,
          render: function (data, type, row) {
            return `
                    <label class="form-label-checkbox fs-6 fw-bolder text-dark">
                      <input class="checkbox list" type="checkbox" label="My Value" name="primary" row-id="${row.id}">
                      <span class="checkmark"></span>
                    </label>`;
          },
        },
        {data: 'id', name: 'id'},
        {data: 'first_name', name: 'first_name'},
        {data: 'last_name', name: 'last_name'},
        {data: 'email', name: 'email'},
        {
          data: 'roles.0.name',
          render: function (data, type, row) {
            return `${row?.roles?.[0]?.name}`;
          },
        },
        {
          data: 'avatar',
          orderable: false,
          searchable: false,
          render: function (data, type, row) {
            let img = avatarBlank;
            const mediaItem = row.media?.find(item => item.collection_name == 'avatar');
            if (mediaItem) img = mediaItem.original_url;
            return `<div class="image" ${row.id} style="background: url(${img});"></div>
                    <div class="customer-status" title="${row.is_active ? "Active" : "Blocked"}">
                      <span class="${row.is_active ? "bg-success" : "bg-danger"}"></span>
                    </div>
                    `;
          },
        },
        {
          data: 'actions',
          searchable: false,
          orderable: false,
          render: function (data, type, row) {
            return `
                    <button type="button"
                        class="btn-primary me-2 mb-2 actions">
                        Actions
                        <i class="fas fa-caret-down"></i>
                    </button>
                    <div class="row-actions display-none hidden-actions">
                        <div class="absolute-div">
                            <button 
                            class="btn btn-primary me-2 mb-4 mt-1 show"
                            row-id="${row.id}" row-name="${row.name}">
                                <i class="fas fa-eye"></i> Show
                            </button>
                            <button 
                            class="btn btn-primary me-2 mb-4 mt-1 edit"
                            row-id="${row.id}" row-name="${row.name}">
                                <i class="fas fa-edit"></i> Edit
                            </button>
                            <button 
                            class="btn btn-${row.is_active ? "danger" : "warning"} me-2 mt-1 status"
                            row-id="${row.id}" row-name="${row.first_name}" row-email="${row.email}" row-status="${row.is_active ? "active" : "blocked"}">
                                <i class="fas fa-${row.is_active ? "lock" : "unlock"}"></i> ${row.is_active ? "Block" : "Unblock"}
                            </button>
                        <div>
                    </div>
                    `;
          },
        }
      ],
      "order": [[0, "desc"]],
    });

    table.off('click');

    table.on('click', 'button.actions', function () {
      if ($(this).next(".row-actions").hasClass("hidden-actions")) {
        $(this).next(".row-actions").fadeIn(100).removeClass("hidden-actions");
      } else {
        $(this).next(".row-actions").fadeOut(100).addClass("hidden-actions");
      }
    });

    table.on('click', 'button.show', function () {
      const id = ($(this).attr("row-id"));
      navigate(`/admins/${id}`)
    });

    table.on('click', 'button.edit', function () {
      const id = ($(this).attr("row-id"));
      navigate('/admins/' + id + '/edit');
    });

    table.on('click', 'button.status', function () {
      const id = ($(this).attr("row-id"));
      const name = ($(this).attr("row-name"));
      const email = ($(this).attr("row-email"));
      const status = ($(this).attr("row-status"));
      toggleActiveStatus(id, name, email, status, table);
    });

    table.on('click', 'thead tr:first-child th:nth-child(6)', function () {
      return false;
    });

    $("<span class='table-filter-icon br-0-95-rem' title='Filter'><i class='fa fa-filter fs-4 br-1000'></i>Filter</span>")
      .insertAfter("#admins_length label");

    $(".table-filter-icon").click(function () {
      $(".toggle-filter").slideToggle(100)

      let condition = $(".table-filter-icon i").hasClass("fa-filter");

      $(".table-filter-icon")
        .html(condition ? "<i class='far fa-times-circle fs-4 br-1000'></i>Close"
          : "<i class='fa fa-filter fs-4 br-1000'></i>Filter");
    });

    let datatableSearch = ".dataTables_wrapper .dataTables_filter input[type=search]";
    $("<i class='fas fa-search'></i>")
      .insertBefore(datatableSearch);
    $(datatableSearch)
      .attr("placeholder", "Search...");

    table.on('draw', function () {
      $(".paginate_button.page-item.previous a").html('<i class="fas fa-chevron-left"></i>');
      $(".paginate_button.page-item.next a").html('<i class="fas fa-chevron-right"></i>');
    });

    table.on('click', '.form-label-checkbox .checkbox', function () {
      const id = ($(this).attr("row-id"));
      setBulkArray(cur => _.xor(cur, [id]));
    });

    $('.toggle-filter').each(function () {
      if ($(this).css('display') == 'block') {
        $(".table-filter-icon").html("<i class='far fa-times-circle fs-4 br-1000'></i>Close");
      }
    });

    table.on('click', '.form-label-checkbox .checkbox.mark-all', function () {
      if ($(this).is(':checked')) {
        setBulkArray([]);
        let allId = [];
        $(".form-label-checkbox .checkbox.list").each(function (index) {
          if ($(this).is(':checked') == false) {
            $(this).click();
          }
          allId.push($(this).attr("row-id"));
        });
        setBulkArray(allId);
      } else {
        $(".form-label-checkbox .checkbox.list").each(function (index) {
          if ($(this).is(':checked') == true) {
            $(this).click();
          }
        });
        setBulkArray([]);
      }
    });

    table.on('draw', function () {
      $(".pagination .page-item").click(function () {
        resetMarked();
      });
      resetMarked();
      $(".form-label-checkbox #mark-all").click().click();
    });

    $("table.dataTable thead tr:first-child th:nth-child(1)")
      .html(`<label class="form-label-checkbox form-label-checkbox-mark-all  fs-6 fw-bolder text-dark pt-0">
         <input class="checkbox mark-all" type="checkbox" id="mark-all" label="My Value" name="primary">
         <span class="checkmark"><span></span></span>
         </label>`);

    const toggleActiveStatus = (id, name, email, status, table) => {
      swal({
        title: "Are you sure?",
        text: `You want to ${status == "active" ? "block" : "unblock"} user "${name !== 'null' ? name : email}"`,
        icon: "warning",
        buttons: true,
        dangerMode: true,
        confirm: {
          text: "Yes",
          value: true,
          visible: true,
          className: "",
          closeModal: true
        }
      }).then((result) => {
        if (result == true) {
          axios.post('admin-is-active-toggle/' + id)
            .then((res) => {
              if (res.status == 200) {
                swal(`User "${name !== 'null' ? name : email}" has been ${status == "active" ? "blocked" : "unblocked"}!`, {
                  icon: "success",
                });
                table.draw(false);
                return true;
              } else {
                return false;
              }
            }).catch(function (error) {
            console.log(error);
          });
        }
      });
    }

  }

  const resetMarked = () => {
    if ($(".form-label-checkbox .checkbox.mark-all").is(":checked")) {
      $(".form-label-checkbox .checkbox.mark-all").click();
    }
    $(".form-label-checkbox .checkbox.list").each(function (index) {
      if ($(this).is(':checked') == true) {
        $(this).click();
      }
    });
    setBulkArray([]);
  }

  //Bulk Action Start()
  const bulkBlockUnblockAdmin = (unblock) => {
    swal({
      title: "Are you sure?",
      text: `You want to ${unblock ? "unblock" : "block"} marked user?`,
      icon: "warning",
      buttons: true,
      dangerMode: true,
      confirm: {
        text: "Yes",
        value: true,
        visible: true,
        className: "",
        closeModal: true
      }
    }).then((result) => {
      if (result == true) {
        axios.post('bulk-admin-status', {
          admins: bulkArray,
          value: unblock,
        })
          .then(function (res) {
            if (res.status == 200) {
              swal(`Users has been ${unblock ? "unblocked" : "blocked"} successfully!`, {
                icon: "success",
              });
              resetMarked();
              $('#admins').DataTable().draw(false);
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.data.errors);
            }
          });
      }
    });
  }
  //Bulk Action End()

  const resetFilter = () => {
    setFilterParams(filterInitialValues);
    localStorage.removeItem("DataTables_admins_/admins");
    triggerDatatable(true);
    setOnlyBlockedChecked(false);
  }

  const bulkDeleteAdmins = () => {
    confirmAlert('You want to delete marked admins?', handleDelete, ["No", "Yes"])
  };

  const handleDelete = () => {
    axios.post('bulk-admin-destroy', {
      admins: bulkArray,
    })
      .then(function (res) {
        if (res.status == 200) {
          swal(`Admins has been deleted successfully!`, {
            icon: "success",
          });

          resetMarked();
          $('#admins').DataTable().draw(false);
        }
      })
      .catch(function (error) {
        if (error.response) {
          console.log(error.response.data.errors);
        }
      });
  }

  return (
    <>
      <div>
        <div className="admins toggle-filter display-none">
          <form onSubmit={triggerFilter} className="row">

            <div className="fv-row mb-10 col-xxl-2 col-lg-6">
              <label className="form-label fs-6 fw-bolder color-dark-grey">ID</label>
              <input className="form-control form-control-lg form-control-solid"
                     type="text"
                     name="id"
                     onChange={(e) => setFilterParams({
                       ...filterParams,
                       id: parseInt(e.target.value)
                     })}
                     value={filterParams.id}
              />
            </div>
            <div className="fv-row mb-10 col-xxl-2 col-lg-6">
              <label className="form-label fs-6 fw-bolder color-dark-grey">First Name</label>
              <input className="form-control form-control-lg form-control-solid"
                     type="text"
                     name="first_name"
                     onChange={(e) => setFilterParams({
                       ...filterParams,
                       first_name: e.target.value
                     })}
                     value={filterParams.first_name}
              />
            </div>
            <div className="fv-row mb-10 col-xxl-2 col-lg-6">
              <label className="form-label fs-6 fw-bolder color-dark-grey">Last Name</label>
              <input className="form-control form-control-lg form-control-solid"
                     type="text"
                     name="last_name"
                     onChange={(e) => setFilterParams({
                       ...filterParams,
                       last_name: e.target.value
                     })}
                     value={filterParams.last_name}
              />
            </div>
            <div className="fv-row mb-10 col-xxl-2 col-lg-6">
              <label className="form-label fs-6 fw-bolder color-dark-grey">Email</label>
              <input className="form-control form-control-lg form-control-solid"
                     type="text"
                     name="email"
                     onChange={(e) => setFilterParams({
                       ...filterParams,
                       email: e.target.value
                     })}
                     value={filterParams.email}
              />
            </div>
            <div className="fv-row mb-10 col-xxl-2 col-lg-6">
              <label className="form-label fs-6 fw-bolder color-dark-grey">Role</label>
              <input className="form-control form-control-lg form-control-solid"
                     type="text"
                     name="role"
                     onChange={(e) => setFilterParams({
                       ...filterParams,
                       role: e.target.value
                     })}
                     value={filterParams.role}
              />
            </div>
            <div className="fv-row mb-10 col-xxl-2 col-lg-6">
              <label className="form-label fs-6 fw-bolder color-dark-grey">Only Blocked</label>
              <label className="form-label-checkbox filter fs-6 fw-bolder text-dark">
                <input className="checkbox list"
                       type="checkbox"
                       name="only_blocked"
                       label="My Value"
                       checked={onlyBlockedChecked}
                       onChange={(e) => {
                         setOnlyBlockedChecked(e.target.checked);
                         setFilterParams({
                           ...filterParams,
                           only_blocked: e.target.checked
                         })
                       }
                       }
                />
                <span className="checkmark"></span>
              </label>
            </div>

            <div className="col-12">
              <button
                className="btn btn-primary"
                title="Filter Table"
                type="submit"
                onClick={triggerFilter}
              >
                <i className="fas fa-sync-alt fs-5 mr-2"></i>
                Filter
              </button>
              <button
                type="button"
                className="btn btn-lg btn-primary clear-filter ml-2 py-3 px-5"
                title="Clear Filter"
                onClick={resetFilter}
              >
                  <span className="indicator-label clear-filter-icon">
                    <i className="fa fa-times-circle fs-3 display-contents"></i>
                  </span>
                <span className="clear-filter-text">Clear</span>
              </button>
            </div>
          </form>
        </div>
        <div className="text-right pb-3">
          <div className={`marked-actions d-inline-block ${buttonIsDisabled ? " d-none" : ""}`}>
            <span className="d-inline-block border-end pr-3 mr-3">
              {isSuperAdmin &&
                <button
                  type="button"
                  className="btn btn-danger mr-3 br-12-5-px w-10-rem"
                  onClick={() => bulkDeleteAdmins()}
                  disabled={buttonIsDisabled}
                >
                  <i className="far fa-trash-alt fs-5 mr-2"></i> Delete
                </button>
              }
              <button
                type="button"
                className="btn btn-success mr-3 br-12-5-px w-10-rem"
                onClick={() => bulkBlockUnblockAdmin(true)}
                disabled={buttonIsDisabled}
              >
                <i className="fas fa-lock-open fs-5 mr-2"></i> Unblock
              </button>
              <button
                type="button"
                className="btn btn-danger br-12-5-px w-10-rem"
                onClick={() => bulkBlockUnblockAdmin(false)}
                disabled={buttonIsDisabled}
              >
                <i className="fas fa-lock fs-5 mr-2"></i> Block
              </button>
            </span>
          </div>
          <button type="button"
                  className="btn btn-primary br-12-5-px mr-3"
                  data-bs-toggle="tooltip"
                  title="Coming Soon"
                  onClick={() => {
                    navigate('/admins/create');
                  }}
          >
            <i className="fas fa-plus-circle fs-5 mr-2"></i>
            Add Admin
          </button>
        </div>
        <table id="admins" className="table align-middle table-row-dashed fs-6 gy-5">
          <thead>
          <tr className="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
            <th></th>
            <th>ID</th>
            <th>First name</th>
            <th>Last name</th>
            <th>Email</th>
            <th>Role</th>
            <th>Avatar</th>
            <th>Actions</th>
          </tr>
          </thead>
          <tbody className="text-gray-600 fw-bold">
          </tbody>
        </table>
      </div>
    </>
  );
}